module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAZCAYAAADe1WXtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADKSURBVHgB7ZThDYIwEIXfEf6LE8AIbiAbOIKj6ApuABu4gXUDN7BsoBPUd1qIP0xoBX7BS16PHPRLQ+5VnHN3ABZjitALRpTyZIKTZimXWh/oG4ZrS18TLpWHamND7xCng6+6r6FNKiKWv8D4F5Yu2asQKO7d6/eshQKVl2ACLdA5Q9MfvZwzVyJcWQhUU9UgAspD5H3QNrLBUPrZB60ZtSMC9b7qRB6sXW+Z0zlDv0eqoFf4Qz6BXQDakxpf1/QZcTrRJT4ptNp4AedwQCQIOkYwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/template-icon.png
// module id = 9yfc
// module chunks = 1